import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { TransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { FLOW } from '../IDataflow';
import { PivotTransformation } from 'app/model/dataflow/pivottransformation';
import { ExpressionBasedColumnVisitorAdapterUtils } from '../expression-based-column-visitor-adapter.utils';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PivotTransformation),
    asynchronous: true
})
export class PivotTransformationAdapter extends TransformationAdapter<PivotTransformation> {
    public async getDslScript(pivotTransformation: PivotTransformation): Promise<string> {
        const props: string[] = [];
        if (pivotTransformation.groupByColumns.length > 0) {
            props.push(ExpressionBasedColumnVisitorAdapterUtils.getGroupByColumnsDsl(pivotTransformation));
        }
        const quotes = pivotTransformation.pivotKeyColumn.returnType.typeString === 'string' ? `'` : '';
        const values: string[] = [];
        pivotTransformation.pivotKeyValues.forEach((value) => {
            if (value) {
                values.push(`${quotes}${value}${quotes}`);
            }
        });
        if (pivotTransformation.nullValue) {
            values.push('null');
        }
        const pivotKeyValues = pivotTransformation.pivotKeyValues.length ? `, [${values.join(', ')}]` : '';
        if (pivotTransformation.pivotKeyColumn.expression) {
            props.push(`pivotBy(${pivotTransformation.pivotKeyColumn.expression}${pivotKeyValues})`);
        }

        if (pivotTransformation.expressionColumns.length) {
            props.push(
                await ExpressionBasedColumnVisitorAdapterUtils.writeToDsl(
                    this.context.contextData,
                    pivotTransformation.expressionColumns,
                    pivotTransformation
                )
            );
        }

        props.push(`columnNaming: '${pivotTransformation.ColumnNamePatternFormatted}'`);
        props.push(`lateral: ${pivotTransformation.lateralColumnArrangement}`);
        const partition = TransformationAdapter.getPartitionDslScript(pivotTransformation);
        if (partition) {
            props.push(partition);
        }
        const knownProps = `${props.join(',\n\t')}`;
        const unknownProps = this._getUnknownProps(pivotTransformation, knownProps);
        const transformationData = [knownProps, unknownProps].filter((c) => !!c).join(',\n\t');

        return `${this._getInputStreams(pivotTransformation)} ${
            PivotTransformation.MODEL.name
        }(${transformationData}) ${FLOW} ${this._getOutputStreams(pivotTransformation)}`;
    }
}
